import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ListResultDTO } from 'src/app/helpers/listResult.interface';
import { environment } from 'src/environments/environment';
import { RiskCategoryDTO, RiskCategoryFilters } from '../../models/risk-category.model';

@Injectable({
  providedIn: "root"
})
export class LaravelRiskCategoryService {


  constructor(private httpClient: HttpClient) { }

  private get ROUTES() {
    return {
 
      list: environment.baseUrl + "/api/risk_categories",
      show: environment.baseUrl + "/api/risk_category",
      store: environment.baseUrl + "/api/risk_category",
      destroy: environment.baseUrl + "/api/risk_category",
  
    };
  }

  public list(page: number,
    per_page: number,
    order: string,
    direction: string,
    filters: RiskCategoryFilters,
    includes?: string[]
  ): Observable<ListResultDTO<RiskCategoryDTO>> {
    let params = {};
    if (order) params["order"] = "" + order;
    if (direction) params["direction"] = "" + direction;
    if (includes) params["includes[]"] = includes;
    if (filters) {
      if (filters.search) params["search"] = "" + filters.search;
  }
    if (per_page) {
      params["per_page"] = "" + per_page;
      if (page) params["page"] = "" + page;
      return this.httpClient.get<ListResultDTO<RiskCategoryDTO>>(this.ROUTES.list, {
        params: new HttpParams({ fromObject: params })
      });
    } else {
      return this.httpClient.get<RiskCategoryDTO[]>(this.ROUTES.list, {
        params: new HttpParams({ fromObject: params })
      }).pipe(
        map(results => {
          return {
            data: results,
            total: results.length
          };
        })
      );
    }
  }


  public getRiskCategoryById(id: number): Observable<RiskCategoryDTO> {
    let params = { id: "" + id };
    return this.httpClient.get<RiskCategoryDTO>(this.ROUTES.show, {
      params: new HttpParams({
        fromObject: params
      })
    });

  }

  public upsert(risk_category: RiskCategoryDTO): Observable<RiskCategoryDTO> {
    if (risk_category.id) {
      return this.httpClient.put<RiskCategoryDTO>(`${this.ROUTES.store}`, { risk_category });
    } else {
      return this.httpClient.post<RiskCategoryDTO>(`${this.ROUTES.store}`, { risk_category });
    }
  }

  public delete(id: number): Observable<any> {
    let params = { id: "" + id };
    return this.httpClient.delete(this.ROUTES.destroy, {
      params: new HttpParams({
        fromObject: params
      })
    });
  }
}
